import React from 'react';
import { images } from '../../assets';
import './FavouriteArtists.css';
import FadeInSection from '../FadeInSection/FadeInSection';

const FavouriteArtists: React.FC = () => {
  return (
    <section className="favourite-artists-section">
      <picture>
        <source srcSet={require('../../assets/images/favourite-artists-mobile.jpg')} media="(max-width: 768px)" />
        <img 
          src={images.favouriteArtists} 
          alt="Favourite Artists Background" 
          className="favourite-artists-bg"
        />
      </picture>
      <div className="favourite-artists-content">
        <FadeInSection>
          <h2 className="favourite-artists-title">
          Your favourite artists, guided by science
          </h2>
        </FadeInSection>
        <FadeInSection delay={600}>
          <p className="favourite-artists-description">
          Heal combines the music you love with exclusive breathwork & sound for your mental and physical longevity.
        </p>
        </FadeInSection>
      </div>
    </section>
  );
};

export default FavouriteArtists; 